import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import DigitalLectureCourseCard from './DigitalLectureCourseCard'

export default class DigitalLectureCourseListResult extends BaseModel {
  static override constructorName = 'DigitalLectureCourseListResult'

  items: DigitalLectureCourseCard[] = []
  pagination: PaginationData = new PaginationDataModel()

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.items = convertToArrayModels(data.data, DigitalLectureCourseCard)

      this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)
    }
  }
}

registerModel(DigitalLectureCourseListResult)
